import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Material listo para aplicar desde el día 1', 'Ejemplos 100% rioplatenses', 'Tablas de referencia rápida', 'Diálogos modelo para situaciones reales', 'Sin tecnicismos lingüísticos aburridos', 'Optimizado para celular y tablet', 'Audios y pronunciación figurada para argentinos', 'Ejercicios prácticos de autoevaluación', 'Contexto cultural de negocios y turismo', 'Actualizado con el portugués que se habla hoy'];
  return <section className="py-12 bg-black border-y border-emerald-900/40" data-id="element-168">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-169">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-170">
          ✅ Todos los tomos incluyen:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-171">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-zinc-900/50 transition-colors" data-id="element-172">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-173" />
              <span className="text-zinc-100 font-medium text-[16px]" data-id="element-174">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}